export default "__VITE_ASSET__ELxjBHDJ__"